<template>
    <div>
        <accommodation-review-filter :distribution-list="distributionList" @search="setFilter" :loading="loading" :hasProperty="false"></accommodation-review-filter>
        <accommodation-review-table :distribution-list="distributionList"  @busyToggled="toggleBusy" :filter="filter"></accommodation-review-table>
    </div>
</template>

<script>
    import AccommodationReviewTable from "@/components/review/accommodation/list/AccommodationReviewTable";
    import AccommodationReviewFilter from "@/components/review/accommodation/list/AccommodationReviewFilter";
    import {cloneDeep} from "lodash";
    import {getDistributionList} from "@/services/distribution";
    export default {
        name: "Index",
        components: {AccommodationReviewFilter, AccommodationReviewTable},
        data(){
            return{
                filter: null,
                loading: false,
                distributionList:[]
            }
        },
        methods: {
            setFilter(values) {
                this.filter = cloneDeep(values)
            },
            toggleBusy($event) {
                this.loading = $event
            }
        },
        created(){
            getDistributionList({company: 1, for_reservation: 1, sorted: 1}).then(res => {
                this.distributionList = res.data
            })
        }
    }
</script>

<style scoped>

</style>
